
import { forwardRef } from "react";

// components/RetailerCard.jsx
const RetailerCard = forwardRef(function RetailerCard({ name, address, description, website, onClick, isSelected }, ref) {
  return (
    <li
      ref={ref}
      className={`p-4 rounded-lg border cursor-pointer transition
        ${isSelected ? "border-red-500 bg-red-50 ring-2 ring-red-300" : "border-gray-200"}`}
      onClick={onClick}
    >
      <h3 className="font-bold">{name}</h3>
      <p className="text-sm text-gray-600">{address}</p>
      <a href={website} className="text-blue-600 underline text-sm">Visit site</a>
      {description && <p className="mt-2 text-sm">{description}</p>}
    </li>
  );
});

export default RetailerCard;
